import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { States } from 'app/_models/states';
import { CommonservicesService } from 'app/_services/commonservices.service';
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from '@angular/material/sort';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
 

@Component({
  selector: 'app-state-master',
  templateUrl: './state-master.component.html'
 
})
export class StateMasterComponent implements OnInit, AfterViewInit {
  states: States[];
  displayedColumns: string[] = ["S.No", "stateName"];
  dataSource = new MatTableDataSource<States>([]);
  @ViewChild(MatPaginator, {static: false})  set paginator(value: MatPaginator) {   this.dataSource.paginator = value;   }
  @ViewChild(MatSort, {static: false})  set sort(value: MatSort) {   this.dataSource.sort = value; }
  isLoaderResult = false;
  resultLength = 0

  constructor
              (
                public datepipe: DatePipe,
                private readonly  commonService: CommonservicesService,
                private readonly _liveAnnouncer: LiveAnnouncer
             ) 
             {
   
  
            }

  ngOnInit(): void {
    this.isLoaderResult = true;
    this.getstates();

  }

  getstates()
  {
    this.commonService.getStates().subscribe(state => {
      this.states = state;
      this.dataSource = new MatTableDataSource<States>(this.states);
      this.resultLength = this.states.length;
      this.isLoaderResult = false;
    });
   
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
     
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  exportExcel()
  {
    const workSheet = XLSX.utils.json_to_sheet(this.dataSource.data.map((item) => {return { StateName: item.stateName  };}  ));
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
    let fileName ="States_" + this.datepipe.transform(new Date(), 'dd_MM_yyyy_hh_mm')+".xlsx";
    XLSX.writeFile(workBook, fileName);
  }

}
